/*
 * Ryan O'Dowd
 * 2024-05-13
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Surface as PaperSurface,
} from 'react-native-paper';
import React from 'react';
import getStyles from './styles';
import hooks from '@hooks';

const Surface = (props: React.ComponentProps<typeof PaperSurface>) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <PaperSurface
      {...props}
      style={[styles.container, props.style]}
    >
      {props.children}
    </PaperSurface>
  );
};

export default Surface;
